{
	"title": "Коментари",
	"statuses": {
		"inValidation": "В процес на валидиране",
		"rejected": "Отхвърлено",
		"assured": "Потвърдено",
		"flagged": "Маркирано",
		"resolved": "Решено"
	}
}
